import React from "react";
import Reactselect from "react-select";
import DateRangePicker from "react-daterange-picker";
import { components } from 'react-select';

const CustomValueContainerForDate = ({ children, ...props }) => {
      return (
            <components.ValueContainer {...props}>
                  {React.Children.map(children, child =>
                        child && child.type !== components.Input ? child : null
                  )}
            </components.ValueContainer>
      );
};

const DropdownIndicator = props => {
      return (
            <components.DropdownIndicator {...props}>
                  <i className="far fa-calendar fa-sm" style={{ color: '#333' }} aria-hidden="true"></i>
            </components.DropdownIndicator>
      );
};

export default function RangedDate({
  ref,
  setShowCalender,
  datePickerValue,
  reactSelectCustomStyles,
  onChange,
  showCalender,
  label,
  placeholder,
  renderKey,
  onDateSelect,
  value,
  id
}) {
  return (
    <div
      className="grid-item"
      id={id}
      style={{
        flexBasis: "2.4%",
        fontSize: "14px",
        marginBottom: "10px",
      }}
      ref={ref}
    >
      <div className="dropdown-label"> {label} </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingRight: "10px",
        }}
        onClick={setShowCalender}
      >
        <Reactselect
          id="demo-select-small"
          name={placeholder}
          readOnly
          isClearable
          placeholder={placeholder}
          styles={reactSelectCustomStyles}
          value={value}
          components={{
            ValueContainer: CustomValueContainerForDate,
            DropdownIndicator,
          }}
          menuIsOpen={false}
          onChange={onChange}
          classNamePrefix="react-select"
        />
      </div>
      {showCalender && (
        <div style={{ position: "relative" }}>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: -3,
              zIndex: 9999,
              backgroundColor: "white",
            }}
          >
            <DateRangePicker
              key={renderKey}
              value={datePickerValue}
              onSelect={onDateSelect}
              singleDateRange={true}
            />
          </div>
        </div>
      )}
    </div>
  );
}
